import { NgModule, Renderer2 } from '@angular/core';
import { PreloadAllModules, PreloadingStrategy, RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layouts/layout.component';

// Auth
import { AuthGuard } from './core/guards/auth.guard';
import { NoAuthGuard } from './core/guards/no-auth.guard';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () =>
      import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard],runGuardsAndResolvers: 'always'
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./account/account.module').then(m => m.AccountModule), canActivate: [NoAuthGuard] 
  },
  {
    path: '**', pathMatch: 'full',
    loadChildren: () =>
      import('./account/auth/errors/errors.module').then(m => m.ErrorsModule), canActivate: [AuthGuard],

  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'}
  )],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
